import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { initializeBrowserTelemetry, trackPageView } from './appInsights';
import { releaseMetadata } from './releaseMetadata';

export default function BrowserTelemetryProvider({ children }) {
  const location = useLocation();

  useEffect(() => {
    initializeBrowserTelemetry(releaseMetadata);
  }, []);

  useEffect(() => {
    const routeName = `${location.pathname}${location.search ? '?redacted' : ''}`;
    trackPageView(routeName);
  }, [location.pathname, location.search]);

  return children || null;
}
